export type PixelData = Uint16Array;
export type Palette = string[];
export type FloatingLayerPixel = string | null;
export type FloatingLayerUpdate = FloatingLayerPixel | undefined;
export type Layer = 'base' | 'top';
export type NotificationTone = 'error' | 'info';

export interface Sprite {
    /** Collision-safe nanoid — opaque; display names never derive from it. */
    id: string;
    name: string;
    pixelData: PixelData;
    overlayPixelData: PixelData;
    history: PixelData[];
    redoHistory: PixelData[];
    overlayHistory: PixelData[];
    overlayRedoHistory: PixelData[];
}

export interface EditorNotification {
    id: number;
    message: string;
    tone: NotificationTone;
}

export type Tool = 'brush' | 'eraser' | 'fill' | 'select';

export const GRID_SIZE = 32;
export const TOTAL_PIXELS = GRID_SIZE * GRID_SIZE;

export const PRESET_COLORS = [
    '#be4a2f', '#d77643', '#ead4aa', '#e4a672',
    '#b86f50', '#733e39', '#3e2731', '#a22633',
    '#e43b44', '#f77622', '#feae34', '#fee761',
    '#63c74d', '#3e8948', '#265c42', '#193c3e',
    '#124e89', '#0099db', '#2ce8f5', '#ffffff',
    '#c0cbdc', '#8b9bb4', '#5a6988', '#3a4466',
    '#262b44', '#181425', '#ff0044', '#68386c',
    '#b55088', '#f6757a', '#e8b796', '#c28569'
];
